module.exports = __webpack_public_path__ + "img/protect.bda0b596.svg";